import genToken from "@utils/generateToken";

// Kinds whose editor shows one range per category: answers[i] is edited together with ranges[i].
const ONE_RANGE_PER_ANSWER_KINDS = ["conditions", "group_answers", "mailing", "url_param"];

const asList = (from) => (Array.isArray(from) ? from : from ? [from] : []);

// A range's conditions are folded left to right (`operator` links a condition to the next one), so
// several ranges landing on the same category read as "range A or range B".
function mergeConditionRanges(ranges, code) {
  const conditions = ranges.flatMap((range, i) => {
    const list = range.conditions || [];
    if (i === ranges.length - 1) return list;
    return list.map((condition, j) => (j === list.length - 1 ? { ...condition, operator: "or" } : condition));
  });
  return { token: ranges[0]?.token || genToken(), to: code, conditions };
}

// The stock may hold ranges out of answer order, several ranges per category or a range landing on
// no category. The editor pairs answers[i] with ranges[i], so ranges are folded per answer on load.
// AI kinds keep their sentinel range untouched.
export function rangesByAnswer(answers, ranges, recodeKind) {
  if (!ONE_RANGE_PER_ANSWER_KINDS.includes(recodeKind)) return ranges || [];

  return (answers || []).map((answer) => {
    const code = String(answer.code);
    const own = (ranges || []).filter((range) => String(range.to) === code);
    if (recodeKind === "conditions") return mergeConditionRanges(own, code);
    return { token: own[0]?.token || genToken(), to: code, from: own.flatMap((range) => asList(range.from)) };
  });
}

function copyTitle(text, takenTitles) {
  let title = `${text} (copy)`;
  for (let n = 2; takenTitles.includes(title); n++) title = `${text} (copy ${n})`;
  return title;
}

export function duplicateCategory(answer, range, siblings = []) {
  const copy = JSON.parse(JSON.stringify({ answer, range }));
  copy.answer.token = genToken();
  copy.range.token = genToken();
  copy.answer.title = Object.fromEntries(
    Object.entries(copy.answer.title || {}).map(([locale, text]) => [
      locale,
      text?.trim()
        ? copyTitle(
            text,
            siblings.map((sibling) => sibling.title?.[locale]),
          )
        : text,
    ]),
  );
  return copy;
}
